import { CALLBACK_ARGUMENT, ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const SET_OCR_DATA_LOADING = "SET_OCR_DATA_LOADING";
export const SET_OCR_DATA = "SET_OCR_DATA";
export const SET_OCR_ERROR = "SET_OCR_ERROR";
export const RESET_OCR_STATES = "RESET_OCR_STATES";
export const OCR_PROCESS_DOCUMENT_REQUEST = "OCR_PROCESS_DOCUMENT_REQUEST";

export const fetchOcrData = response => ({
  type: OCR_PROCESS_DOCUMENT_REQUEST,
  [WAIT_FOR_ACTION]: SET_OCR_DATA,
  [ERROR_ACTION]: SET_OCR_ERROR,
  [CALLBACK_ARGUMENT]: response => response.payload,
  payload: response
});

export const setOcrDataLoading = (key, isLoading) => ({
  type: SET_OCR_DATA_LOADING,
  payload: { key, isLoading }
});
export const setOcrData = (key, data) => ({
  type: SET_OCR_DATA,
  payload: { key, data }
});
export const setOcrError = (key, error) => ({
  type: SET_OCR_ERROR,
  error: true, // This is crucial for FSA compliance
  payload: { key, error }
});
export const resetOcrStates = () => ({
  type: RESET_OCR_STATES
});
